import { PLATFORM } from '@/common/constants/platform-constants';
import React from 'react';

export const SiteMainButtons = {
  [PLATFORM.STANDALONE]: [
    {
      href: '/login',
      content: '立即体验',
      theme: 'primary',
    },
    {
      href: '/docs',
      content: '帮助文档',
      theme: 'text',
    },
  ],
  [PLATFORM.STANDALONE_WOA]: [{
    href: '//zhiyan.woa.com/plugin_ifbook/1/ifbook',
    content: '前往智研站',
    theme: 'primary',
    hoverContent: (
      <div>
        <div style={{ color: '#00000099', marginBottom: 8, fontSize: 13 }}>前往 ifBook 智研站点，体验一站式 DevOps 平台，ifBook 将以“接口云”的形式集成在智研平台中。</div>
        <div style={{ color: '#4B5B7699', fontSize: 12 }}>注：ifBook 独立站与智研站之间数据暂不互通，体验和创建项目前请谨慎考虑并选择。</div>
      </div>
    ),
  },
  {
    // href: '/tencent/workbench',
    content: '前往独立站（建设中）',
    theme: 'outline',
    disabled: true,
    hoverContent: (
      <div>
        <div style={{ color: '#00000099', marginBottom: 8, fontSize: 13 }}>前往 ifBook 独立站点，聚焦接口设计、开发和测试，体验更专注高效的智能接口工作台。</div>
        <div style={{ color: '#4B5B7699', fontSize: 12 }}>注：ifBook 独立站与智研站之间数据暂不互通，体验和创建项目前请谨慎考虑并选择。</div>
      </div>
    ),
  }, {
    href: '//ifbook.pages.woa.com',
    content: '帮助文档',
    theme: 'text',
  }],
};
